import { Controller } from "stimulus"

// Handles the AI Jobs chat form submission with an immediate
// "thinking" indicator, similar to AI Chat's UX. Submits via
// fetch, shows user message + thinking bubble instantly, then
// replaces the thinking bubble with the real response.
export default class extends Controller {
  static targets = ["messages", "input", "form", "bottom", "onboarding"]

  submit(e) {
    e.preventDefault()

    const form = e.target.closest('form') || this.formTarget
    const input = form.querySelector('textarea, input[name="message"]')
    const message = input?.value?.trim()
    if (!message) return

    // Hide onboarding if present
    const onboarding = document.getElementById('ai-jobs-onboarding')
    if (onboarding) onboarding.remove()

    // Move input to bottom if it's the first message
    const chatInput = document.getElementById('ai-jobs-chat-input')
    const chatBottom = document.getElementById('ai-jobs-chat-bottom')
    if (chatInput && chatBottom && !chatBottom.contains(chatInput)) {
      chatInput.remove()
      chatBottom.appendChild(chatInput)
    }

    // Show user message immediately
    this.appendMessage('user', this.escapeHtml(message))

    // Show thinking indicator
    this.appendThinking()

    // Clear input
    input.value = ''
    input.style.height = 'auto'
    input.dispatchEvent(new Event('input', { bubbles: true }))

    // Submit via fetch
    const formData = new FormData(form)
    formData.set('message', message)

    fetch(form.action, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content,
        'Accept': 'text/html'
      },
      body: formData
    })
    .then(response => response.text())
    .then(html => {
      // Remove thinking indicator
      const thinking = document.getElementById('ai-jobs-thinking')
      if (thinking) thinking.remove()

      // Extract just the assistant message content from the response.
      // The controller returns a simple HTML fragment.
      this.appendMessage('assistant', html)
      this.scrollToBottom()
    })
    .catch(err => {
      const thinking = document.getElementById('ai-jobs-thinking')
      if (thinking) thinking.remove()
      this.appendMessage('assistant', '<p>Something went wrong. Please try again.</p>')
    })
  }

  appendMessage(role, content) {
    const messagesEl = document.getElementById('ai-jobs-chat-messages')
    if (!messagesEl) return

    const icon = role === 'assistant' ? 'fad fa-message-bot' : 'far fa-user'
    const msg = document.createElement('div')
    msg.className = `ai-jobs-chat-msg ai-jobs-chat-msg-${role}`
    msg.innerHTML = `
      <div class="ai-jobs-chat-msg-avatar"><span class="${icon}"></span></div>
      <div class="ai-jobs-chat-msg-body">${content}</div>
    `
    messagesEl.appendChild(msg)
    this.scrollToBottom()
  }

  appendThinking() {
    const messagesEl = document.getElementById('ai-jobs-chat-messages')
    if (!messagesEl) return

    const thinking = document.createElement('div')
    thinking.id = 'ai-jobs-thinking'
    thinking.className = 'ai-jobs-chat-msg ai-jobs-chat-msg-assistant'
    thinking.innerHTML = `
      <div class="ai-jobs-chat-msg-avatar"><span class="fad fa-message-bot"></span></div>
      <div class="ai-jobs-chat-msg-body">
        <p class="mb-0"><span class="fad fa-spinner-third fa-spin mr-2 text-color-highlight"></span><span class="opacity-7">Searching jobs and thinking...</span></p>
      </div>
    `
    messagesEl.appendChild(thinking)
    this.scrollToBottom()
  }

  scrollToBottom() {
    const messagesEl = document.getElementById('ai-jobs-chat-messages')
    if (messagesEl) {
      messagesEl.scrollTop = messagesEl.scrollHeight
    }
  }

  escapeHtml(text) {
    const div = document.createElement('div')
    div.textContent = text
    return div.innerHTML
  }
}
